import React from "react";
import "@/App.css";
import "./i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import ErrorBoundary from "./components/ErrorBoundary";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsNewModal from "./components/WhatsNewModal";
import AdminWhatsNewModal from "./components/AdminWhatsNewModal";
import AdminAIChatWidget from "./components/AdminAIChatWidget";
import ActivityTracker from "./components/ActivityTracker";
import ChatWidget from "./components/ChatWidget";
import ChatLauncher from "./components/ChatLauncher";
import { useAuth } from "./context/AuthContext";
import { AdminNotificationsProvider } from "./context/AdminNotificationsContext";
import { ChatProvider } from "./context/ChatContext";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import Terms from "./pages/Terms";
import CookieBanner from "./components/CookieBanner";
import Dashboard from "./pages/Dashboard";
import Account from "./pages/Account";
import Outlet from "./pages/Outlet";
import ChiSiamo from "./pages/ChiSiamo";
import Admin from "./pages/Admin";
import Preventivatore from "./pages/Preventivatore";
import MagicSearchPage from "./pages/MagicSearchPage";
import AdminIMTask from "./pages/AdminIMTask";
import Projects from "./pages/Projects";
import Suppliers from "./pages/Suppliers";
import Contatti from "./pages/Contatti";
import ProtectedRoute from "./components/ProtectedRoute";
import SupplierCredsPopup from "./components/SupplierCredsPopup";
import SharedOutlet from "./pages/SharedOutlet";
import StoreInsightRecorder from "./pages/StoreInsightRecorder";
import SharedAssets from "./pages/SharedAssets";


function Shell({ children }) {
  const { user } = useAuth();
  return (
    <AdminNotificationsProvider user={user}>
    <ChatProvider user={user}>
    <div className="min-h-screen flex flex-col bg-cream">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsNewModal />
      <AdminWhatsNewModal />
      <CookieBanner />
      <SupplierCredsPopup />
      {/* Assistente AI globale — visibile solo agli admin (montato in Shell = ogni pagina) */}
      <AdminAIChatWidget user={user} />
      {/* Tracker tempo di attività reale (solo admin, ogni pagina) */}
      <ActivityTracker user={user} />
      {/* Chat WhatsApp-style utenti↔admin (pannello flottante) */}
      <ChatWidget />
      {/* Launcher flottante chat per gli utenti (mascotte animata, "Chatta con noi") */}
      <ChatLauncher />
    </div>
    </ChatProvider>
    </AdminNotificationsProvider>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Shell><Landing /></Shell>} />
            <Route path="/login" element={<Shell><Login /></Shell>} />
            <Route path="/register" element={<Shell><Register /></Shell>} />
            <Route path="/forgot-password" element={<Shell><ForgotPassword /></Shell>} />
            <Route path="/reset-password" element={<Shell><ResetPassword /></Shell>} />
            <Route path="/privacy" element={<Shell><PrivacyPolicy /></Shell>} />
            <Route path="/cookie-policy" element={<Shell><CookiePolicy /></Shell>} />
            <Route path="/termini-condizioni" element={<Shell><Terms /></Shell>} />
            <Route path="/outlet" element={<Shell><Outlet /></Shell>} />
            <Route path="/chi-siamo" element={<Shell><ChiSiamo /></Shell>} />
            <Route path="/dashboard" element={<ProtectedRoute><Shell><Dashboard /></Shell></ProtectedRoute>} />
            <Route path="/account" element={<ProtectedRoute><Shell><Account /></Shell></ProtectedRoute>} />
            <Route path="/progetti" element={<ProtectedRoute><Shell><Projects /></Shell></ProtectedRoute>} />
          <Route path="/fornitori" element={<ProtectedRoute><Shell><Suppliers /></Shell></ProtectedRoute>} />
            <Route path="/contatti" element={<ProtectedRoute><Shell><Contatti /></Shell></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><Shell><Admin /></Shell></ProtectedRoute>} />
            <Route path="/preventivatore" element={<ProtectedRoute adminOnly><Shell><Preventivatore /></Shell></ProtectedRoute>} />
            <Route path="/magic-search" element={<ProtectedRoute><Shell><MagicSearchPage /></Shell></ProtectedRoute>} />
            <Route path="/admin/imtask" element={<ProtectedRoute adminOnly><Shell><AdminIMTask /></Shell></ProtectedRoute>} />
            {/* Public share outlet — NO Shell (niente navbar/footer/auth) */}
            <Route path="/share/:token" element={<SharedOutlet />} />
            {/* Public asset share (48h) — NO Shell (niente navbar/footer/auth) */}
            <Route path="/asset-share/:token" element={<SharedAssets />} />
            {/* Store Insight — registrazione note vocali da cellulare (link pubblico, no Shell) */}
            <Route path="/rec/:token" element={<StoreInsightRecorder />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
